// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","fontDefault":"1.6rem","textColorDark":"#3d3d3d"};